import { render, staticRenderFns } from "./s02.vue?vue&type=template&id=5bc0a98b&scoped=true&"
var script = {}
import style0 from "./s02.vue?vue&type=style&index=0&id=5bc0a98b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc0a98b",
  null
  
)

export default component.exports